import React from 'react';
import { Button, Tooltip } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { useWorkspace } from '../../context/WorkspaceContext';

export default function WorkspaceToolbarButton() {
  const { isLoggedIn, displayName, openLogin, logout } = useWorkspace();

  if (isLoggedIn) {
    return (
      <Tooltip title="Sign out (saved calculations stay on server under this username)">
        <Button
          color="inherit"
          size="small"
          onClick={logout}
          startIcon={<PersonOutlineIcon />}
          sx={{ textTransform: 'none', ml: 1 }}
        >
          {displayName}
        </Button>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Sign in to save and view your calculations">
      <Button
        color="inherit"
        size="small"
        onClick={openLogin}
        startIcon={<PersonOutlineIcon />}
        sx={{ textTransform: 'none', ml: 1 }}
      >
        Sign in
      </Button>
    </Tooltip>
  );
}
